<template>
    <div>
        <label class="label" v-if="showLabel && label">{{ label }}</label>
        <component
            aria-role="menu"
            class="dropdown dropdown-listed dropdown-workspaceuser"
            :class="{ 'is-disabled': iniDisabled }"
            :mobile-modal="false"
            :position="position"
            @active-change="addFocus"
            :disabled="iniDisabled"
            :is="iniDisabled ? 'div' : 'bDropdown'">
            <a
                :class="[
                    'button is-trigger',
                    condensed ? 'is-icon' : 'pl5-xs',
                    !iniDisabled && v && v.$anyError ? 'is-danger' : 'is-cancel is-outlined',
                ]"
                slot="trigger">
                <loader v-if="isLoading || (isFetching && !selectedValue)" text=" " />
                <template v-if="selectedValue && (!isMultiple || selectedValue.length > 0)">
                    <template v-if="isMultiple">
                        <template v-for="user in selectedValue.slice(0, maxVisible)">
                            <UserAvatar
                                :key="user.id"
                                :firstName="user.profile.firstName"
                                :lastName="user.profile.lastName"
                                :url="user.profile.avatarUrl"
                                :condensed="condensed || selectedValue.length > 1"
                                class="sm m0" />
                        </template>
                        <span class="ml5-xs" v-if="selectedValue.length > maxVisible">
                            +{{ selectedValue.length - maxVisible }}
                        </span>
                    </template>
                    <template v-else>
                        <UserAvatar
                            :firstName="selectedValue.profile.firstName"
                            :lastName="selectedValue.profile.lastName"
                            :url="selectedValue.profile.avatarUrl"
                            :condensed="condensed"
                            class="sm m0" />
                    </template>
                    <template v-if="!condensed">
                        <span
                            class="button is-detailMenu icon on-hover"
                            @click.prevent="showDetailClick(isMultiple ? selectedValue[0] : selectedValue)"
                            v-if="showDetail">
                            <font-awesome-icon :icon="['fas', 'eye']" />
                        </span>
                        <span class="icon m0" @click.prevent="clear" v-if="!iniDisabled">
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </span>
                    </template>
                    <template v-if="condensed">
                        <span class="icon" v-if="!iniDisabled">
                            <font-awesome-icon :icon="['fas', 'angle-down']" />
                        </span>
                    </template>
                </template>
                <template v-else>
                    <div class="avatar sm m0 blank" v-if="!iniDisabled && !isLoading">
                        <span class="img">
                            <font-awesome-icon :icon="['fas', 'user']" />
                        </span>
                        <div class="meta" v-if="!condensed">
                            <div class="name fade-50">
                                {{ showLabel && !iniDisabled ? $t(isMultiple ? 'chooseUsers' : 'chooseUser') : '' }}
                            </div>
                        </div>
                    </div>
                    <span class="icon" v-if="!iniDisabled"> <font-awesome-icon :icon="['fas', 'angle-down']" /> </span>
                </template>
            </a>
            <template v-if="!iniDisabled">
                <template v-if="showCurrentUser">
                    <b-dropdown-item aria-role="menu-item" has-link>
                        <a
                            href="javascript:void(0)"
                            @click.prevent="(e) => onCheckbox(e, currentUser.Id)"
                            class="v-center">
                            <template v-if="isMultiple">
                                <chooseInput type="CHECKBOX" :value="currentUserIsSelected" class="m0" />
                            </template>
                            <UserAvatar
                                :firstName="currentUser.profile.firstName"
                                :lastName="currentUser.profile.lastName"
                                :url="currentUser.profile.avatarUrl"
                                :condensed="false"
                                class="sm" />
                        </a>
                    </b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem" />
                </template>
                <template v-if="showSearch">
                    <b-dropdown-item aria-role="menu-item" custom>
                        <textInput type="SEARCH" v-model="searchTerm" @input="doSearch" ref="search" />
                    </b-dropdown-item>

                    <div class="head">
                        <span v-if="count" class="mr5-xs">{{ count }}</span>
                        {{ $t('searchResults') }}
                    </div>
                </template>
                <b-dropdown-item aria-role="menu-item" v-if="isLoading" class="is-info">
                    <loader :text="$t('searching')" />
                </b-dropdown-item>
                <b-dropdown-item
                    aria-role="menu-item"
                    v-else-if="data && data.length == 0 && !isLoading"
                    class="is-info"
                    >{{ $t('noUsersFound') }}</b-dropdown-item
                >
                <template v-else-if="data && data.length > 0">
                    <b-dropdown-item aria-role="menu-item" :key="index" v-for="(item, index) in data" has-link>
                        <a
                            href="javascript:void(0)"
                            @click.prevent="(e) => onCheckbox(e, item.id)"
                            class="v-center"
                            v-if="item._visible">
                            <template v-if="isMultiple">
                                <chooseInput type="CHECKBOX" :value="item._selected" class="m0" />
                            </template>
                            <UserAvatar
                                :firstName="item.profile.firstName"
                                :lastName="item.profile.lastName"
                                :url="item.profile.avatarUrl"
                                :condensed="false"
                                class="sm" />
                        </a>
                    </b-dropdown-item>
                </template>
                <pagination
                    :count="count"
                    v-model="pagination"
                    :hidePerPage="true"
                    :iniPerPage="10"
                    @input="paginateChange"></pagination>

                <template v-if="showClearSelection">
                    <hr class="dropdown-divider" aria-role="menuitem" />
                    <b-dropdown-item aria-role="menu-item" @click="clear">
                        <span class="icon">
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </span>
                        <span> {{ $t('clearSelection') }} </span>
                    </b-dropdown-item>
                </template>
            </template>
        </component>
    </div>
</template>
<script>
import paginationMixin from './../mixins/pagination.js';
import { stringToHslColor } from './../mixins/helpers.js';
import UserAvatar from './UserAvatar.vue';

import { getWorkspaceUsers, getWorkspaceUser, getClientWorkspaceUsers } from './../services/workspace.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAngleDown, faEye, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
const chooseInput = () => import('./chooseInput.vue');

library.add(faAngleDown);
library.add(faEye);
library.add(faTimes);
library.add(faUser);

export default {
    name: 'WorkspaceUserSelect',
    components: { UserAvatar, FontAwesomeIcon, chooseInput },
    props: {
        value: [Object, Array],
        v: [Object, Function],
        userId: [String], //optional, if used the user is fetched
        label: { type: String },
        showLabel: { type: Boolean, default: true },
        iniDisabled: { type: Boolean, default: false },
        hideDetail: { type: Boolean, default: false },
        showCurrentUser: { type: Boolean, default: true },
        clientUsersOnly: { type: Boolean, default: false },
        condensed: { type: Boolean, default: false },
        position: { type: String },
        isMultiple: { type: Boolean, default: false },
        maxVisible: {
            type: Number,
            default: 3,
        },
    },
    mixins: [paginationMixin],
    data() {
        return {
            selectedValue: this.isMultiple ? [] : null,
            data: null,
            isLoading: false,
            isFetching: false,
            searchTerm: '',
        };
    },
    computed: {
        currentUser() {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser) {
                currentUser.id = currentUser.Id;
            }
            return currentUser;
        },
        currentUserIsSelected() {
            if (this.data) {
                let user = this.data.find((user) => user.id == this.currentUser.id);
                return user ? user._selected : false;
            }
            return false;
        },
        showSearch() {
            return this.count - this.pagination.perPage > 0 || (this.searchTerm && this.searchTerm.length > 0);
        },
        showClearSelection() {
            if (this.condensed) {
                if (this.isMultiple) {
                    return this.selectedValue && this.selectedValue.length > 0;
                } else {
                    return this.selectedValue;
                }
            }
            return false;
        },
        showDetail() {
            if (this.hideDetail) {
                return false; // don't show by prop
            }
            if (this.isMultiple && this.value.length > 1) {
                return false; //if multiple items are selected don't show
            }
            return true;
        },
    },
    watch: {
        showCurrentUser() {
            this.fetchData();
        },
        value() {
            this.handleValue();
        },
        searchTerm() {
            if (!this.searchTerm) {
                this.clearSearch();
            } else {
                this.doSearch();
            }
        },
        userId(newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                this.handleUserId();
            }
        },
    },
    created() {
        this.handleValue();
        this.handleUserId();
    },
    methods: {
        stringToHslColor,
        addFocus(active) {
            if (active) {
                if (!this.data) {
                    //fetch data is not yet fetched
                    this.fetchData();
                }
                if (this.$refs.search) {
                    this.$nextTick(() => {
                        this.$refs.search.$el.querySelector('input').focus();
                    });
                }
            }
        },
        async handleValue() {
            if (this.isMultiple) {
                this.fetchData();
            } else {
                this.selectedValue = this.value;
            }
        },
        async handleUserId() {
            if (this.userId) {
                this.isFetching = true;
                var user = await getWorkspaceUser({ userId: this.userId })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((e) => {});
                if (this.isMultiple) {
                    this.selectedValue = [user];
                } else {
                    this.selectedValue = user;
                }
                this.$emit('input', this.selectedValue);
            }
            this.isFetching = false;
        },
        paginateChange(newPagination) {
            this.fetchData(newPagination);
        },
        async fetchData(pagination = this.pagination) {
            this.isLoading = true;
            if (!this.data) {
                //when not already fetched
                let payload = {
                    page: pagination.currentPage + 1,
                    itemsPerPage: pagination.perPage,
                    searchTerm: this.searchTerm,
                    active: this.iniDisabled ? false : true,
                };

                if (this.clientUsersOnly) {
                    await getClientWorkspaceUsers(payload)
                        .then((response) => {
                            this.data = response.data;
                            this.count = response.count;
                        })
                        .catch((e) => {});
                } else {
                    await getWorkspaceUsers(payload)
                        .then((response) => {
                            this.data = response.data;
                            this.count = response.count;
                        })
                        .catch((e) => {});
                }
            }

            //visible or not: if showCurrentUser, the user is visible separatly
            this.data = this.data.map((user) => {
                user._visible = true;
                if (user.id == this.currentUser.id) {
                    user._visible = !this.showCurrentUser;
                }
                return user;
            });

            //handle selected variable
            if (this.isMultiple) {
                this.data = this.data.map((user) => {
                    //console.log('searching in', this.value);
                    // Check if value is set
                    let selected = false;
                    if (Array.isArray(this.value)) {
                        selected = this.value.some((item) => {
                            if (typeof item == 'string') {
                                return item == user.id;
                            } else if (typeof item == 'object') {
                                return item.id == user.id;
                            }
                            return false;
                        });
                    }
                    user._selected = selected;

                    return user;
                });

                //check if data has the current value (could be the case when switching in pagination)
                if (Array.isArray(this.value)) {
                    this.value.forEach((user) => {
                        if (typeof user == 'object') {
                            let found = this.data.find((x) => {
                                return x.id == user.id;
                            });
                            if (!found) {
                                this.data.unshift(user);
                            }
                        }
                    });
                }

                this.selectedValue = this.data.filter((user) => {
                    return user._selected;
                });
            }

            this.isLoading = false;

            return new Promise((resolve, reject) => {
                resolve();
            });
        },
        showDetailClick(item) {
            document.dispatchEvent(
                new CustomEvent('showDetailObject', {
                    detail: {
                        id: item.id,
                        type: 'USER',
                        meta: { title: item.profile.firstName },
                    },
                })
            );
        },
        clear(e) {
            this.selectedValue = null;
            if (this.isMultiple && this.data) {
                this.data = this.data.map((user) => {
                    user._selected = false; //reset checks
                    return user;
                });
            }
            this.$emit('input', this.selectedValue);
            if (e) {
                e.stopPropagation();
            }
        },
        onCheckbox(e, userId) {
            const user =
                this.data.find((u) => u.id === userId) ||
                (this.currentUser && this.currentUser.Id === userId ? this.currentUser : null);
            //console.log('clicked user', user);
            if (!user) return;

            if (this.isMultiple) {
                this.data = this.data.map((user) => {
                    if (user.id == userId) {
                        user._selected = !user._selected;
                    }
                    return user;
                });
                this.selectedValue = this.data.filter((user) => user._selected);
                this.$emit('input', this.selectedValue);
            } else {
                this.$emit('input', user);
                this.selectedValue = user;
            }

            if (this.isMultiple) {
                //stop from closing the dropdown
                if (e) {
                    e.stopPropagation();
                }
            }
        },
        clearSearch(e) {
            this.searchTerm = '';
            this.currentPage = 0;
            this.fetchData();
        },
        doSearch() {
            if (this.searchTerm && this.searchTerm.length > 0) {
                this.currentPage = 0;
                this.fetchData();
            }
        },
    },
    i18n: {
        messages: {
            en: {
                searchResults: 'Search results',
                searching: 'Searching',
                noUsersFound: 'No users found',
                chooseUser: 'Choose user',
                chooseUsers: 'Choose users',
                none: 'None',
                clearSelection: 'Clear selection',
            },
            fr: {
                searchResults: 'Résultats de recherche',
                searching: 'Recherche en cours',
                noUsersFound: 'Aucun utilisateur trouvé',
                chooseUser: 'Choisir un utilisateur',
                chooseUsers: 'Choisir des utilisateurs',
                none: 'Aucun',
                clearSelection: 'Effacer la sélection',
            },
            nl: {
                searchResults: 'Zoekresultaten',
                searching: 'Bezig met zoeken',
                noUsersFound: 'Geen gebruikers gevonden',
                chooseUser: 'Kies een gebruiker',
                chooseUsers: 'Kies gebruikers',
                none: 'Geen',
                clearSelection: 'Selectie wissen',
            },
        },
    },
};
</script>

<style lang="scss">
html body .dropdown.dropdown-workspaceuser {
    &.dropdown.is-disabled {
        opacity: 1;
        cursor: default;
        .button.is-trigger.is-cancel {
            border-color: transparent;
            background-color: transparent;
            &:hover {
                color: var(--text-color);
                border-color: transparent;
                //border-color: var(--background-color-darker);
                background-color: transparent;
                cursor: default;
            }
        }
    }

    .button.is-trigger.is-danger {
        text-transform: none;
        background-color: #fff;
        text-transform: none;
        color: var(--text-color);
        border-color: var(--danger);
        color: var(--danger);
        .fade-50 {
            opacity: 1;
        }
        .avatar.blank {
            span.img {
                background-color: var(--danger);
                color: #fff;
            }
        }
    }
    .button.is-trigger.is-cancel {
        text-transform: none;
        background-color: #fff;
        text-transform: none;
        color: var(--text-color);

        span.on-hover {
            opacity: 0;
        }
        &:hover {
            span.on-hover {
                cursor: pointer;
                opacity: 1;
            }
        }
    }

    .button.is-detailMenu {
        width: 25px;
        height: 25px;
    }

    .avatar.blank {
        span.img {
            background-color: var(--background-color-darker);
            color: var(--txt-color);
        }
    }
}
</style>
